import { render, staticRenderFns } from "./ContentsDetail.vue?vue&type=template&id=43843f26"
import script from "./ContentsDetail.vue?vue&type=script&lang=js"
export * from "./ContentsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports